import logo from '../../assets/images/brand/header_logo.png';
import heroLogo from '../../assets/images/brand/header_main.png';
import winnerIcon from '../../assets/images/apps/icons/winner.webp';
import plinkoIcon from '../../assets/images/apps/icons/plinko.webp';
import iceFishingIcon from '../../assets/images/apps/icons/ice-fishing.webp';
import bigWinIcon from '../../assets/images/apps/icons/big-win.webp';
import zeusIcon from '../../assets/images/apps/icons/zeus.webp';
import crownIcon from '../../assets/images/apps/icons/crown.webp';
import newBonusIcon from '../../assets/images/apps/icons/new-bonus.webp';
import towerRushIcon from '../../assets/images/apps/icons/tower-rush.webp';
import { languages } from '../../i18n/translations';

const MANAGER_URL = 'https://t.me/BandaApps_Manager';

const OrbitIcon = ({ src, angle }) => (
  <span className="orbit-slot" style={{ transform: `rotate(${angle}deg)` }}>
    <span className="orbit-spin">
      <span className="orbit-app" style={{ transform: `rotate(${-angle}deg)` }}>
        <img src={src} alt="" />
      </span>
    </span>
  </span>
);

const renderTitle = (title) =>
  title.split('|').map((part, index) =>
    index % 2 === 1
      ? <span className="accent" key={index}>{part}</span>
      : <span key={index}>{part}</span>,
  );

export const Header = ({
  isMenuOpen,
  language,
  onLanguageChange,
  onMenuToggle,
  onNavigate,
  t,
}) => (
  <header className="hero" id="top">
    <div className="hero__glow" />
    <div className="site-header">
      <div className="site-header__bar">
        <a className="site-header__logo" href="#top" aria-label="Banda Apps">
          <img src={logo} alt="Banda Apps" />
        </a>

        <button
          className={`menu-button ${isMenuOpen ? 'is-open' : ''}`}
          type="button"
          aria-expanded={isMenuOpen}
          aria-label="Menu"
          onClick={onMenuToggle}
        >
          <span />
          <span />
        </button>

        <nav className={`site-nav ${isMenuOpen ? 'is-open' : ''}`} aria-label="Main navigation">
          <div className="site-nav__links">
            <a href="#apps" onClick={onNavigate}>{t('nav.about')}</a>
            <a href="#advantages" onClick={onNavigate}>{t('nav.advantages')}</a>
            <a href="#contacts" onClick={onNavigate}>{t('nav.contacts')}</a>
          </div>

          <span className="site-nav__divider" aria-hidden="true" />

          <div className="site-nav__actions">
            <div className="language-switcher" aria-label="Language">
              {languages.map((item) => (
                <button
                  className={language === item ? 'is-active' : ''}
                  key={item}
                  type="button"
                  onClick={() => onLanguageChange(item)}
                >
                  {item}
                </button>
              ))}
            </div>

            <a className="site-header__cta" href={MANAGER_URL} target="_blank" rel="noreferrer" onClick={onNavigate}>
              {t('hero.cta')}
            </a>
          </div>
        </nav>
      </div>
    </div>

    <div className="hero__content">
      <div className="hero__copy">
        <h1>{renderTitle(t('hero.title'))}</h1>
        <p>{t('hero.description')}</p>
        <a className="button button--primary" href={MANAGER_URL} target="_blank" rel="noreferrer">
          {t('hero.cta')}
        </a>
      </div>

      <div className="hero__art" aria-hidden="true">
        <div className="hero__orbit hero__orbit--one">
          <OrbitIcon src={winnerIcon} angle={18} />
          <OrbitIcon src={iceFishingIcon} angle={108} />
          <OrbitIcon src={zeusIcon} angle={198} />
          <OrbitIcon src={crownIcon} angle={288} />
        </div>
        <div className="hero__orbit hero__orbit--two">
          <OrbitIcon src={plinkoIcon} angle={45} />
          <OrbitIcon src={bigWinIcon} angle={135} />
          <OrbitIcon src={newBonusIcon} angle={225} />
          <OrbitIcon src={towerRushIcon} angle={315} />
        </div>
        <img className="hero__art-logo" src={heroLogo} alt="" />
      </div>
    </div>
  </header>
);
